export const spotifyFollowMetaData = {
    isRepeatable: false
}
